import apiClient from "./apiClient";

const questionnaireApplicationsApi = {
  getNom035Config: async (applicationId) => {
    const response = await apiClient.get(
      `/questionnaire-applications/${applicationId}/nom035-config`
    );
    return response.data;
  },

  validateEmployeeCredentials: async (applicationId, employeeCredentials) => {
    const response = await apiClient.post(
      `/questionnaire-applications/${applicationId}/validate-employee-credentials`,
      employeeCredentials
    );
    return response.data;
  },

  getByBranch: async (branchId) => {
    const response = await apiClient.get("/questionnaire-applications", {
      params: { branchId },
    });
    return response.data;
  },

  getById: async (applicationId) => {
    const response = await apiClient.get(`/questionnaire-applications/${applicationId}`);
    return response.data;
  },

  update: async (applicationId, applicationName) => {
    const response = await apiClient.put(`/questionnaire-applications/${applicationId}`, {
      applicationName,
    });
    return response.data;
  },

  getJobAreas: async (applicationId, options = {}) => {
    const response = await apiClient.get(
      `/questionnaire-applications/${applicationId}/job-areas`,
      { params: { page: options.page || 1, pageSize: options.pageSize || 10 } }
    );
    return response.data;
  },

  createJobArea: async (applicationId, jobArea) => {
    const response = await apiClient.post(
      `/questionnaire-applications/${applicationId}/job-areas`,
      { jobArea }
    );
    return response.data;
  },

  updateJobArea: async (applicationId, jobAreaId, jobArea) => {
    const response = await apiClient.put(
      `/questionnaire-applications/${applicationId}/job-areas/${jobAreaId}`,
      { jobArea }
    );
    return response.data;
  },

  deleteJobArea: async (applicationId, jobAreaId) => {
    const response = await apiClient.delete(
      `/questionnaire-applications/${applicationId}/job-areas/${jobAreaId}`
    );
    return response.data;
  },

  create: async ({
    branchId,
    applicationName,
    typeApplication,
    jobAreas = [],
    employeesFile = null,
    useBranchJobAreas = false,
    useBranchEmployees = false,
    usesEmployeeCredentials = false,
  }) => {
    const formData = new FormData();
    formData.append("branchId", branchId);
    formData.append("applicationName", applicationName);
    formData.append("typeApplication", typeApplication);
    if (["nom035", "nom035SecI"].includes(typeApplication)) {
      formData.append("jobAreas", JSON.stringify(jobAreas));
      formData.append("useBranchJobAreas", String(useBranchJobAreas));
      formData.append("useBranchEmployees", String(useBranchEmployees));
      formData.append("usesEmployeeCredentials", String(usesEmployeeCredentials));
      if (employeesFile) formData.append("employeesFile", employeesFile, employeesFile.name);
    }

    const response = await apiClient.post("/questionnaire-applications", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
};

export default questionnaireApplicationsApi;
